import { render, staticRenderFns } from "./ap3AccessGate.vue?vue&type=template&id=28684ff3"
import script from "./ap3AccessGate.vue?vue&type=script&lang=js"
export * from "./ap3AccessGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28684ff3')) {
      api.createRecord('28684ff3', component.options)
    } else {
      api.reload('28684ff3', component.options)
    }
    module.hot.accept("./ap3AccessGate.vue?vue&type=template&id=28684ff3", function () {
      api.rerender('28684ff3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ap3AccessGate.vue"
export default component.exports